// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'es6-promise/auto'
import Vue from 'vue'
import Raven from 'raven-js'
import RavenVue from 'raven-js/plugins/vue'
import BootstrapVue from 'bootstrap-vue'
import VeeValidate from 'vee-validate'
import App from './App'
import { router } from './router'
import store from './store'
import VueNotifications from 'vue-notifications'
import miniToastr from 'mini-toastr'

import 'font-awesome/css/font-awesome.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'simple-line-icons/css/simple-line-icons.css'
import 'vue-multiselect/dist/vue-multiselect.min.css'

Raven
    .config(process.env.SENTRY_DSN, { environment: process.env.SENTRY_ENV, debug: process.env.SENTRY_DEBUG })
    .addPlugin(RavenVue, Vue)
    .install()

Vue.use(BootstrapVue)

// --start-- vue-notifications with mini-toastr
const toastTypes = {
  success: 'success',
  error: 'error',
  info: 'info',
  warn: 'warn'
}
miniToastr.init({ types: toastTypes })

function toast ({ title, message, type, timeout, cb }) {
  return miniToastr[type](message, title, timeout, cb)
}

const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
}
Vue.use(VueNotifications, options)
VueNotifications.config.timeout = 4000
// --end-- vue-notifications with mini-toastr

// --start-- vee-validate
const config = {
  errorBagName: 'errors', // change if property conflicts
  fieldsBagName: 'vee-fields',
  delay: 0,
  locale: 'en',
  dictionary: null,
  strict: true,
  classes: true,
  classNames: {
    touched: 'touched', // the control has been blurred
    untouched: 'untouched', // the control hasn't been blurred
    valid: 'is-valid', // model is valid
    invalid: 'is-invalid', // model is invalid
    pristine: 'pristine', // control has not been interacted with
    dirty: 'dirty' // control has been interacted with
  },
  events: 'input|blur',
  inject: true,
  validity: false,
  aria: true
}
Vue.use(VeeValidate, config)
// --end-- vee-validate

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js